import { asyncThunkCreator, buildCreateSlice } from '@reduxjs/toolkit';
export var createAsyncSlice = buildCreateSlice({
    creators: { asyncThunk: asyncThunkCreator },
});
